import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddActTransComp from "./Component/AddActTransComp"


const AddActTrans =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddActTransComp />
        </div>
        <Footer />
        </>
    )
}

export default AddActTrans